import { formatDate } from "~/lib/format";
import type { DataFreshness } from "~/types/company";

const SOURCE_LABELS: { key: keyof DataFreshness; label: string }[] = [
	{ key: "ares", label: "ARES" },
	{ key: "justiceCore", label: "Obchodní rejstřík (OR)" },
	{ key: "justiceOfficers", label: "Statutární orgány" },
	{ key: "justiceShareholders", label: "Společníci" },
	{ key: "rzp", label: "Živnostenský rejstřík" },
	{ key: "vat", label: "Registr DPH" },
	{ key: "insolvency", label: "Insolvenční rejstřík" },
	{ key: "documents", label: "Sbírka listin" },
];

/** Per-source "synchronizováno" stamps under the profile disclaimers. */
export function CompanyDataFreshness({ freshness }: { freshness?: DataFreshness | null }) {
	if (!freshness) return null;

	const stamps = SOURCE_LABELS.filter(({ key }) => freshness[key] != null);
	if (stamps.length === 0) return null;

	return (
		<div className="border-t border-gray-100 pt-3 text-xs text-muted-foreground">
			<h3 className="font-semibold mb-1">Zdroje dat</h3>
			<p className="flex flex-wrap gap-x-3 gap-y-0.5">
				{stamps.map(({ key, label }) => (
					<span key={key}>
						{label}: synchronizováno {formatDate(freshness[key])}
					</span>
				))}
			</p>
		</div>
	);
}
